import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("gw_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/admin/dashboard`, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => setLoading(false))
        .catch(() => {
          setToken(null);
          localStorage.removeItem("gw_token");
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (usernameOrPassword, maybePassword) => {
    const username = maybePassword === undefined ? "admin" : usernameOrPassword;
    const password = maybePassword === undefined ? usernameOrPassword : maybePassword;
    const res = await axios.post(`${API}/admin/login`, { username, password });
    const t = res.data.access_token;
    setToken(t);
    localStorage.setItem("gw_token", t);
    return t;
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem("gw_token");
  };

  const api = useCallback(
    (method, url, data, config = {}) =>
      axios({
        method,
        url: `${API}${url}`,
        data,
        headers: { Authorization: `Bearer ${token}`, ...config.headers },
        ...config,
      }),
    [token]
  );

  return (
    <AuthContext.Provider value={{ token, login, logout, api, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
